import * as React from 'react';
import { cn } from '@/lib/utils/cn';

export function Label({
  className,
  required,
  children,
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement> & { required?: boolean }) {
  return (
    <label className={cn('text-sm font-medium text-foreground', className)} {...props}>
      {children}
      {required && <span className="ml-0.5 text-danger">*</span>}
    </label>
  );
}

/** A labelled form field with optional hint and error message. */
export function Field({
  label,
  htmlFor,
  required,
  error,
  hint,
  className,
  children,
}: {
  label?: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  error?: string | string[] | null;
  hint?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}) {
  const errorText = Array.isArray(error) ? error.join(' ') : error;
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <Label htmlFor={htmlFor} required={required}>
          {label}
        </Label>
      )}
      {children}
      {hint && !errorText && <p className="text-xs text-muted-foreground">{hint}</p>}
      {errorText && <p className="text-xs font-medium text-danger-text">{errorText}</p>}
    </div>
  );
}
